import React, { useRef } from 'react';
import Typography from '@material-ui/core/Typography';
import {
    Button,
    ButtonGroup,
    Col,
    Container,
    Dropdown, DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Input, InputGroup, InputGroupAddon, InputGroupText,
} from "reactstrap";
import DatePicker from "react-datepicker";
import { sort } from "fast-sort";
import QRCode from "qrcode";
import { getRights, getUserById, getUserId } from "../functions/Auth";
import {
    addDeliverySignature, changeDeliveryCarID,
    changeDeliveryLocation,
    changeDeliveryStatus, changeDriverID, getAllDriversCache, getDeliverySignature,
    getDeliveryStatusColor,
    splitDeliveryRemark,
    changeDeliveryProposedDatetime,
    getDeliveryPhoto,
    addDeliveryPhoto,
    deleteDeliveryPhoto,
    changeDeliveryRemark,
    changeDeliveryInternalRemark,
    changeDeliveryAddress
} from "../functions/Delivery";
import SpinnerOverlay from "./components/SpinnerOverlay";
import { isEmpty, sleep, addPhoneLink, getImageType, calculateArraySum } from "../functions/Utility";
import DeliveryRecordGoogleMapModal from "./DeliveryRecordGoogleMapModal";
import DeliveryRecordSignatureModal from "./DeliveryRecordSignatureModal";
import DeliveryRecordUpdateDeliveryRemarkModal from "./DeliveryRecordUpdateDeliveryRemarkModal";
import GeneralConfirmModal from "./GeneralConfirmModal";
import BillRecordDetailModal from "./BillRecordDetailModal";
import { getBillRecordById } from "../functions/Bill";
import { getAllCarsFromCache } from "../functions/Car";
import { getBillStatusColor, isPaid, getBillDevileryWhatsappString } from "../functions/Bill";
import { getDateString, convertFileToBase64, resizeFile } from "../functions/Utility";
import { saveAs } from 'file-saver';
import DeliverySignatureArea from './components/DeliverySignatureArea';
import DeliveryPhotoArea from './components/DeliveryPhotoArea';
import DeliveryRecordUpdateInternalDeliveryRemarkModal from './DeliveryRecordUpdateInternalDeliveryRemarkModal';
import DeliveryRecordUpdateDeliveryAddressModal from './DeliveryRecordUpdateDeliveryAddressModal';
import { addSystemLog } from '../functions/SystemLog';

const fs = require('fs');

function DeliveryRecordDetailModal(props) {
    const { isOpen, toggle, data } = props;
    const driver = data && !isEmpty(data) ? getUserById(data.driverID) : {};

    const [isLoading, setIsLoading] = React.useState(false);
    //  Driver Dropdown toggle
    const [driverDropdownOpen, setDriverDropdownOpen] = React.useState(false);
    const driverDropdownToggle = () => setDriverDropdownOpen(prevState => !prevState);
    const onDriverDropdownSelect = async (driverID) => {
        setIsLoading(true);
        await changeDriverID(data.deliveryID, driverID);
        await addSystemLog(getUserId(), "2002", data.deliveryID, "WEB-更新送貨司機 " + driverID) ;
        await sleep(500);
        data.driverID = driverID;
        setIsLoading(false);
    };
    //  Car ID Dropdown toggle
    const [carIdDropdownOpen, setCarIdDropdownOpen] = React.useState(false);
    const carIdDropdownToggle = () => setCarIdDropdownOpen(prevState => !prevState);
    const onCarIdDropdownSelect = async (carID) => {
        setIsLoading(true);
        await changeDeliveryCarID(data.deliveryID, carID);
        await addSystemLog(getUserId(), "2002", data.deliveryID, "WEB-更新送貨車牌 "+ carID);
        await sleep(500);
        data.carID = carID;
        setIsLoading(false);
    };
    //  Select delivery status
    const onButtonSelect = async (status) => {
        setIsLoading(true);
        await changeDeliveryStatus(data.deliveryID, status);

        await addSystemLog(getUserId(), "2002", data.deliveryID, "WEB-更新送貨狀態 " + status);


        await sleep(500);
        data.deliveryStatus = status;
        setIsLoading(false);    //  Render update the loading state and changed delivery status
    };
    //  QR code
    const [invoiceUrlQrCode, setInvoiceUrlQrCode] = React.useState("");
    const [deliveryNoteUrlQrCode, setDeliveryNoteUrlQrCode] = React.useState("");
    //  Google Map
    const [isGoogleMapOpen, setIsGoogleMapOpen] = React.useState(false);
    const onLocationSelected = async (position) => {
        setIsLoading(true);
        await changeDeliveryLocation(data.deliveryID, position);


        await addSystemLog(getUserId(), "2002", data.deliveryID, "WEB-更新送貨GPS定點");

        Object.assign(data, {
            address_GPS_latitude: position.latitude,
            address_GPS_longtitude: position.longitude
        });
        setIsLoading(false);
    };
    //  Signature
    const [signatureModalIsOpen, setSignatureModalIsOpen] = React.useState(false);
    const [signatureImageBase64, setSignatureImageBase64] = React.useState("");

    //  Bill detail
    const [billDetailIsOpen, setBillDetailIsOpen] = React.useState(false);
    const [billData, setBillData] = React.useState(null);

    //  Date change
    const datePickerRef = useRef(null);
    const [proposedDateTime, setProposedDateTime] = React.useState(new Date());   //  State of date picker
    const onProposedDateTimeChange = async (date) => {
        setIsLoading(true);
        await changeDeliveryProposedDatetime(data.deliveryID, date);

        await addSystemLog(getUserId(), "2002", data.deliveryID, "WEB-更新送貨時間");

        await sleep(500);
        setIsLoading(false);
    };

    // whatsapp text to customer
    const [whatsappTextToCustomer, setWhatsappTextToCustomer] = React.useState("");

    // copy button
    const [copyButtonFlag, setCopyButtonFlag] = React.useState(false);

    // change date picker
    const [isDateValueChanged, setIsDateValueChanged] = React.useState(false);

    // image to upload 
    // const [imageFileToUpload, setImageFileToUpload] = React.useState();

    // Delivery Photo from dB
    const [deliveryPhotoBase64, setDeliveryPhotoBase64] = React.useState('');
    const [deleteDeliveryPhotoModalIsOpen, setDeleteDeliveryPhotoModalIsOpen] = React.useState(false);

    //  Update Delivery address 
    const [updateAddressIsOpen, setUpdateAddressIsOpen] = React.useState(false);
    const [deliveryAddressText, setDeliveryAddressText] = React.useState("");

    //  Update Delivery Remark 
    const [updateInternalDeliveryRemarkIsOpen, setUpdateInternalDeliveryRemarkIsOpen] = React.useState(false);
    const [updateDeliveryRemarkIsOpen, setUpdateDeliveryRemarkIsOpen] = React.useState(false);
    const [deliveryRemarkST, setDeliveryRemarkST] = React.useState("");
    const [deliveryInternalRemarkText, setDeliveryInternalRemarkText] = React.useState('');

    // upload delivery photo
    const inputUploadExistingPhoto = useRef(null);

    const uploadImage = async (imageToUpload) => {
        setIsLoading(true);
        //resize file will auto encoded to base 64
        let imageToUploadResized = await resizeFile(imageToUpload);
        let imageBase64 = imageToUploadResized;
        let imageBase64HeaderRemoved = imageBase64.split(',')[1];
        // remove the header from the image
        await addDeliveryPhoto(data.deliveryID, imageBase64HeaderRemoved);


        await addSystemLog(getUserId(), "2001", data.deliveryID, "WEB-新增送貨圖片");


        setDeliveryPhotoBase64(imageBase64HeaderRemoved);
        setIsLoading(false);
    };


    // delete delivery photo
    const deleteDeliveryPhotoCmd = async (deliveryID) => {
        setIsLoading(true);
        await deleteDeliveryPhoto(deliveryID);
        setDeliveryPhotoBase64('');
        setIsLoading(false);
    };

    // Weight of this delivery
    const [deliveryWeight, setDeliveryWeight] = React.useState(0);


    React.useEffect(() => {
        if (!data || isEmpty(data)) return;
        //  Initial API call
        const initData = async () => {
            let signatureData, invoiceQrCode, deliveryNoteQrCode;
            let deliveryPhotoData;
            setIsLoading(true);
            // signature
            signatureData = await getDeliverySignature(data.deliveryID);
            setSignatureImageBase64(signatureData.ImageBase64Content);

            // invoice QR code
            if (data.invoiceUrl) {
                invoiceQrCode = await QRCode.toDataURL(data.invoiceUrl);
                setInvoiceUrlQrCode(invoiceQrCode);
            }
            if (data.deliveryNoteUrl) {
                deliveryNoteQrCode = await QRCode.toDataURL(data.deliveryNoteUrl);
                setDeliveryNoteUrlQrCode(deliveryNoteQrCode)
            }
            // time picker: proposedDateTime
            setProposedDateTime(new Date(data.proposedDateTime));

            // deliveryRemark
            setDeliveryRemarkST(data.deliveryRemark);

            // deliveryInternalRemark
            setDeliveryInternalRemarkText(data.deliveryInternalRemark);

            // delivery address
            setDeliveryAddressText(data.address);

            // deliveryPhoto from backend
            deliveryPhotoData = await getDeliveryPhoto(data.deliveryID);
            setDeliveryPhotoBase64(deliveryPhotoData.ImageBase64Content);

            setWhatsappTextToCustomer(getBillDevileryWhatsappString(
                data.paymentID
                , data.invoiceUrl
                , data.customerName
                , data.billRemark
                , data.address));


            //weight 
            setDeliveryWeight(
                calculateArraySum(data.goods.map((good) => (good.goodDefaultWeight * good.quantity)))
            );

            setIsLoading(false);
        };
        initData().then();
    }, [data]);

    return data ? (
        <Modal isOpen={isOpen} toggle={toggle}>
            {isLoading ? <SpinnerOverlay /> : ""}
            <ModalHeader toggle={toggle}>
                <div className="pt-2 pb-2">
                    {addPhoneLink(deliveryAddressText)}
                    <Button className="btn-light ml-1" onClick={() => setIsGoogleMapOpen(true)}>
                        <i className="fas fa-map-marker-alt text-danger" />
                    </Button>
                    <DeliveryRecordGoogleMapModal isOpen={isGoogleMapOpen}
                        toggle={() => setIsGoogleMapOpen(false)}
                        address={deliveryAddressText}
                        initLatitude={data.address_GPS_latitude}
                        initLongitude={data.address_GPS_longtitude}
                        onLocationSelected={onLocationSelected} />
                </div>
                <Typography color="textSecondary">
                    <strong className="bg-warning p-1 text-dark">{data.carID}</strong>{' '}
                    <strong className={"bg-" + (driver ? driver.rights : "") + " p-1 text-dark"}>{driver ? driver.nickName : ""}</strong>{' '}
                    <strong className={"bg-" + getDeliveryStatusColor(data.deliveryStatus) + " p-1 text-dark"}>{data.deliveryStatus}</strong>{' '}
                    <strong className={"bg-" + getBillStatusColor(data.billStatus) + " p-1 text-dark"}>{data.billStatus}</strong>{' '}
                    {isPaid(data.billStatus) === true ? (
                        <>
                            <strong className={"bg-success p-1 text-dark"}>{data.paymentMethod}</strong>
                        </>
                    ) : ""}
                </Typography>
                <Typography className='mt-2' color="textSecondary">
                    <strong>{data.deliveryID}</strong>
                </Typography>
                <Typography className='mt-0' color="textSecondary">
                    <strong>{getDateString(data.proposedDateTime, true, false)}</strong>
                </Typography>
                <Typography variant='h6' className='mt-0' color="Error">
                    <strong>{deliveryInternalRemarkText}</strong>
                </Typography>


                {deliveryRemarkST === "" ? (
                    <>
                        <Typography color="textSecondary">
                            <strong>{`收貨：`}{addPhoneLink(data.billRemark)}</strong>
                        </Typography>
                    </>
                ) :
                    <>
                        {splitDeliveryRemark(deliveryRemarkST).map((remark, index) => (
                            <Typography key={`${data.deliveryID}-remark-${index}`} className="pt-2 m-0 text-info" color="textSecondary">
                                <strong>{`收貨：`}{addPhoneLink(remark)}</strong>
                            </Typography>
                        ))}

                    </>}

            </ModalHeader>
            <ModalBody>


                <ButtonGroup className="mb-2 w-100">
                    <Button color={data.deliveryStatus === '排程中' ? "info" : "secondary"}
                        style={data.deliveryStatus !== '排程中' ? { opacity: 0.5 } : {}}
                        outline={data.deliveryStatus !== '排程中'}
                        onClick={() => onButtonSelect('排程中')}>
                        排程中
                    </Button>
                    <Button color={data.deliveryStatus === '準備好' ? "danger" : "secondary"}
                        style={data.deliveryStatus !== '準備好' ? { opacity: 0.5 } : {}}
                        outline={data.deliveryStatus !== '準備好'}
                        onClick={() => onButtonSelect('準備好')}>
                        準備好
                    </Button>
                    <Button color={data.deliveryStatus === '送緊貨' ? "warning" : "secondary"}
                        style={data.deliveryStatus !== '送緊貨' ? { opacity: 0.5 } : {}}
                        outline={data.deliveryStatus !== '送緊貨'}
                        onClick={() => onButtonSelect('送緊貨')}>
                        送緊貨
                    </Button>
                    <Button color={data.deliveryStatus === '完成' ? "success" : "secondary"}
                        style={data.deliveryStatus !== '完成' ? { opacity: 0.5 } : {}}
                        outline={data.deliveryStatus !== '完成'}
                        onClick={() => onButtonSelect('完成')}>
                        完成
                    </Button>
                </ButtonGroup>



                <Container >
                    <Row className="mb-2">
                        {getRights() !== "driver" &&
                            <>
                                <Button
                                    className='mt-1 mr-2'
                                    color='warning'
                                    onClick={() => {
                                        setUpdateAddressIsOpen(true)
                                    }}
                                >
                                    {'更新地址'}
                                </Button>

                                <DeliveryRecordUpdateDeliveryAddressModal
                                    isOpen={updateAddressIsOpen}
                                    toggle={() => setUpdateAddressIsOpen(false)}
                                    originalText={deliveryAddressText}
                                    onSubmit={async (textToSubmit) => {
                                        setIsLoading(true);
                                        if (textToSubmit && textToSubmit != '') {
                                            // Do not allow empty address
                                            await changeDeliveryAddress(data.deliveryID, textToSubmit);

                                            await addSystemLog(getUserId(), "2002", data.deliveryID, "WEB-更新送貨地址 " + textToSubmit);
                                            setDeliveryAddressText(textToSubmit);
                                        }
                                        setUpdateAddressIsOpen(false);
                                        setIsLoading(false);
                                    }} />
                            </>

                        }

                        {getRights() !== "driver" ? (
                            <>
                                <Button className="mt-1 mr-2" color="info" onClick={() => setUpdateDeliveryRemarkIsOpen(true)}>更新收貨資料</Button>

                                <DeliveryRecordUpdateDeliveryRemarkModal isOpen={updateDeliveryRemarkIsOpen}
                                    toggle={() => setUpdateDeliveryRemarkIsOpen(false)}
                                    originalDeliveryRemark={deliveryRemarkST}
                                    onSubmit={async (deliveryRemarkText) => {
                                        setIsLoading(true);
                                        await changeDeliveryRemark(data.deliveryID, deliveryRemarkText);
                                        await addSystemLog(getUserId(), "2002", data.deliveryID, "WEB-更新送貨備註 " + deliveryRemarkText);
                                        setDeliveryRemarkST(deliveryRemarkText);
                                        setUpdateDeliveryRemarkIsOpen(false);
                                        setIsLoading(false);
                                    }} />
                            </>
                        ) : ""}

                        {getRights() !== "driver" &&
                            <>
                                <Button
                                    className='mt-1 '
                                    color='danger'
                                    onClick={() => {
                                        setUpdateInternalDeliveryRemarkIsOpen(true)
                                    }}
                                >
                                    {'更新內部備註'}
                                </Button>
                                <DeliveryRecordUpdateInternalDeliveryRemarkModal isOpen={updateInternalDeliveryRemarkIsOpen}
                                    toggle={() => setUpdateInternalDeliveryRemarkIsOpen(false)}
                                    originalDeliveryRemark={deliveryInternalRemarkText}
                                    onSubmit={async (internalDeliveryRemarkText) => {
                                        setIsLoading(true);
                                        await changeDeliveryInternalRemark(data.deliveryID, internalDeliveryRemarkText);

                                        await addSystemLog(getUserId(), "2002", data.deliveryID, "WEB-更新送貨內部備註 " + internalDeliveryRemarkText);
                                        setDeliveryInternalRemarkText(internalDeliveryRemarkText);
                                        setUpdateInternalDeliveryRemarkIsOpen(false);
                                        setIsLoading(false);
                                    }} />
                            </>


                        }
                    </Row>
                    <Row className="mb-2">
                        {getRights() !== "driver" ? (
                            <>
                                <Dropdown className="mt-1 mr-2 d-inline" isOpen={carIdDropdownOpen} toggle={carIdDropdownToggle}>
                                    <DropdownToggle caret color="warning">
                                        更改車牌
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        {getAllCarsFromCache().map((car) => {
                                            return <DropdownItem onClick={() => onCarIdDropdownSelect(car.carID)}>{car.carID}</DropdownItem>;
                                        })}
                                    </DropdownMenu>
                                </Dropdown>
                            </>
                        ) : ""}

                        {getRights() !== "driver" ? (
                            <>
                                <Dropdown className="mt-1 mr-2" isOpen={driverDropdownOpen} toggle={driverDropdownToggle}>
                                    <DropdownToggle caret color="primary">
                                        更改司機
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        {getAllDriversCache().map((user) => {
                                            return <DropdownItem onClick={() => onDriverDropdownSelect(user.driver_userId)}>{user.driver_nickName}</DropdownItem>;
                                        })}
                                    </DropdownMenu>
                                </Dropdown>
                            </>
                        ) : ""}


                    </Row>


                    <Row className="mb-2 w-100">
                        {getRights() !== "driver" ? (
                            <>
                                <InputGroup className="mr-2  w-100" >
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText  ><i className="fas fa-clock fa-1x" /></InputGroupText>
                                    </InputGroupAddon>

                                    <DatePicker selected={proposedDateTime}
                                        onChange={(date) => {
                                            setProposedDateTime(date);
                                            setIsDateValueChanged(true); //tuen on the tick button
                                        }}
                                        showTimeSelect //allow time input by select
                                        // withPortal //pop up a new screen to do the selection
                                        timeFormat="HH:mm"
                                        timeCaption="時間"
                                        dateFormat="yyyy-MM-dd EEE HH:mm" />

                                    {(isDateValueChanged === true) ?
                                        <InputGroupAddon addonType="append">
                                            <Button color="success" onClick={async () => {
                                                //  await onDataUpdate({inventory: inventory});
                                                await onProposedDateTimeChange(proposedDateTime);
                                                setIsDateValueChanged(false); //turn off this button
                                            }}>
                                                <i className="fas fa-check" />
                                            </Button>
                                        </InputGroupAddon> : ""
                                    }



                                </InputGroup>
                            </>
                        ) : ""}
                    </Row>
                </Container>

                <Container style={{
                    color: "black",
                    border: "1px solid rgba(0,0,0,.125)",
                    borderRadius: ".25rem",
                }}>
                    <Row className="bg-secondary pt-2 pb-2">
                        <Col xs={8}>項目內容</Col>
                        <Col xs={2} className="p-0">數目</Col>
                        <Col xs={2} className="p-0">單位</Col>
                    </Row>
                    {data.goods.map((good) => (
                        <Row key={`${data.deliveryID}-good-${good.goodID}`} className="pt-2 pb-2">
                            <Col xs={8}>
                                <div>{good.goodDescription}</div>
                                {good.remarks !== "" ? (
                                    <div className="pl-2 text-danger">{good.remarks}</div>
                                ) : ""}
                            </Col>
                            <Col xs={2} className="p-0">{good.quantity}</Col>
                            <Col xs={2} className="p-0">{good.goodUnit}</Col>
                        </Row>
                    ))}
                    <Row className="bg-secondary pt-2 pb-2">
                        <Col xs={8}>總重</Col>
                        <Col xs={2} className="p-0">{Number(deliveryWeight.toFixed(1))}</Col>
                        <Col xs={2} className="p-0">kg</Col>
                    </Row>

                    {deliveryWeight >= 1000 ? (

                        <Row className="bg-secondary pt-2 pb-2">
                            <Col xs={8}></Col>
                            <Col xs={2} className="p-0">{Number((deliveryWeight / 1000).toFixed(2))}</Col>
                            <Col xs={2} className="p-0">噸</Col>
                        </Row>
                    ) : ""}

                </Container>
                <Container>
                    <Row className="m-2 justify-content-center">
                        <a target="_blank" rel="noreferrer" href={data.deliveryNoteUrl}>
                            <img src={deliveryNoteUrlQrCode} alt="invoice-qr-code" />
                        </a>
                    </Row>
                </Container>

                {/* <div className="mt-3 mb-3 p-3 d-flex justify-content-between"
                    style={{
                        backgroundImage: signature ? `url(data:image/${getImageType(signature).ext};base64,${signature})` : "none",
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        border: "3px dotted lightgray",
                        color: "gray",
                        height: "200px"
                    }}>
                    <strong>簽名</strong>
                    <Button className="align-self-end" color="info" size="lg" onClick={() => setSignatureIsOpen(true)}>
                        <i className="fas fa-signature" />
                        <i className="fas fa-pen-fancy" />
                    </Button>
                </div> */}

                <DeliverySignatureArea
                    signatureDataBase64={signatureImageBase64}
                    onOpenSignatureModal={() => setSignatureModalIsOpen(true)}
                />

                <DeliveryRecordSignatureModal isOpen={signatureModalIsOpen}
                    toggle={() => setSignatureModalIsOpen(false)}
                    onSubmit={async (dataUrl) => {
                        let imageBase64 = dataUrl.split(',')[1];
                        setIsLoading(true);
                        await addDeliverySignature(data.deliveryID, imageBase64);

                        await addSystemLog(getUserId(), "2001", data.deliveryID, "WEB-新增送貨簽名");

                        setSignatureImageBase64(imageBase64);
                        setSignatureModalIsOpen(false);
                        setIsLoading(false);
                    }} />

                <DeliveryPhotoArea
                    deliveryID={data.deliveryID}
                    deliveryPhotoBase64={deliveryPhotoBase64}
                    inputUploadExistingPhoto={inputUploadExistingPhoto}
                    onUploadImage={async (fileToUpload) => { await uploadImage(fileToUpload); }}
                    onDeleteImage={() => { setDeleteDeliveryPhotoModalIsOpen(true) }}
                />


                <Typography className="mb-2 text-center" variant="h6" color="textSecondary" gutterBottom>
                    <strong className="text-dark">{data.customerName}</strong>{' '}
                </Typography>
                {data.customerPhoneList.length > 0 ? (
                    <Container style={{
                        color: "black",
                        border: "1px solid rgba(0,0,0,.125)",
                        borderRadius: ".25rem",

                    }}>
                        <Row className="bg-secondary pt-2 pb-2">
                            <Col xs={6}>聯絡人</Col>
                            <Col xs={6} className="p-0">電話</Col>
                        </Row>
                        {sort(data.customerPhoneList).desc(u => u.priority).map((customerPhone, index) => (
                            <Row key={`${data.deliveryID}-customer-phone-${index}`}
                                className="pt-2 pb-2">
                                <Col xs={6}>{customerPhone.phoneUserName}</Col>
                                <Col xs={6} className="p-0">
                                    {addPhoneLink(customerPhone.phoneNumber)}
                                </Col>
                            </Row>
                        ))}
                    </Container>
                ) : ""}
                {data.invoiceUrl ? (
                    <Container>
                        <Row className="m-2 justify-content-center">
                            <a target="_blank" rel="noreferrer" href={data.invoiceUrl}>
                                <img src={invoiceUrlQrCode} alt="invoice-qr-code" />
                            </a>
                        </Row>
                    </Container>
                ) : ""}

                {getRights() !== "driver" ? (
                    <Input style={{
                        height: "260px"
                    }} type="textarea" name="text" id="exampleText" value={whatsappTextToCustomer} />
                ) : ""}

                {getRights() !== "driver" ? (
                    <Container>
                        <Row className="mb-2 justify-content-center">
                            <Button className="d-inline p-3 m-1" size="lg"
                                onClick={async () => {
                                    setCopyButtonFlag(true);
                                    navigator.clipboard.writeText(whatsappTextToCustomer);
                                    await sleep(1000);
                                    setCopyButtonFlag(false);
                                }}
                                color={copyButtonFlag ? "success" : "info"}>

                                <i className="fas fa-file-invoice-dollar" /> 複製文字
                            </Button>
                            <Button className="d-inline p-3 m-1" color="info" size="lg"
                                onClick={async () => {
                                    let billData;
                                    setIsLoading(true);
                                    billData = await getBillRecordById(data.paymentID);
                                    console.log(billData);
                                    setBillData(billData);
                                    setBillDetailIsOpen(true);
                                    setIsLoading(false);
                                }}>
                                <i className="fa fa-clone" /> 發票資料
                            </Button>
                        </Row>
                    </Container>
                ) : ""}
                <BillRecordDetailModal isOpen={billDetailIsOpen}
                    toggle={() => setBillDetailIsOpen(false)}
                    invoiceData={billData} />
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={toggle}>OK</Button>
            </ModalFooter>
            <GeneralConfirmModal isOpen={deleteDeliveryPhotoModalIsOpen}
                headerText={'確認刪除？'}
                toggle={() => setDeleteDeliveryPhotoModalIsOpen(false)}
                onSubmit={async () => {
                    await deleteDeliveryPhotoCmd(data.deliveryID);

                    await addSystemLog(getUserId(), "2003", data.deliveryID, "WEB-刪除送貨圖片");

                    setDeleteDeliveryPhotoModalIsOpen(false);
                }} />
        </Modal >
    ) : <div />;
}

export default DeliveryRecordDetailModal
